/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var DisputeStatus;
(function (DisputeStatus) {
    DisputeStatus["AUTHORIZED"] = "AUTHORIZED";
    DisputeStatus["UNAUTHORIZED"] = "UNAUTHORIZED";
    DisputeStatus["PARTIALLY_ACCEPTED"] = "PARTIALLY_ACCEPTED";
    DisputeStatus["CANCELLED_NOT_PAID"] = "CANCELLED_NOT_PAID";
    DisputeStatus["PENDING"] = "PENDING";
    DisputeStatus["ACCEPTED"] = "ACCEPTED";
    DisputeStatus["DENIED"] = "DENIED";
    DisputeStatus["ELIGIBLE"] = "ELIGIBLE";
    DisputeStatus["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
    DisputeStatus["UNKNOWN"] = "UNKNOWN";
    DisputeStatus["NO_CHARGEBACK"] = "NO_CHARGEBACK";
    DisputeStatus["CHARGEBACKS_NOT_ENABLED"] = "CHARGEBACKS_NOT_ENABLED";
    DisputeStatus["LOCATION_NOT_ENABLED_FOR_CHARGEBACKS"] = "LOCATION_NOT_ENABLED_FOR_CHARGEBACKS";
})(DisputeStatus || (DisputeStatus = {}));
